import { render, staticRenderFns } from "./AssistanceMiPE.vue?vue&type=template&id=7a135ac0&"
import script from "./AssistanceMiPE.vue?vue&type=script&lang=js&"
export * from "./AssistanceMiPE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports